import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UrlConstants} from '../../../constants/url.constants';
import {TrainingDtls} from '../../../models/trainings/training-dtls';

@Injectable({
    providedIn: "root",
})
export class trainingsService {
    readonly http = inject(HttpClient);

    getInitialDtls() {
        return this.http.get<TrainingDtls>(UrlConstants.TRAININGS_INITIAL_DTLS_URL)
    }

    requestTraining(trainingData: TrainingDtls) {
        return this.http.post(UrlConstants.TRAININGS_REQUEST_TRAINING_URL, trainingData, {
            responseType: "text",
        });
    }
}
